function clarifyTransparency() {
  const banner = document.querySelector(".top-banner--dv");
  if (banner?.dataset.index !== "1") {
    const header = document.querySelector('.header-dv__section--container');
    header.classList.add('static');
  }
}

document.addEventListener("DOMContentLoaded", function() {
  // Get the hamburger and close icons
  const hamburger = document.querySelector('.header-dv__menu-item__navigation.open');
  const close = document.querySelector('.header-dv__menu-item__navigation.close');
  const mobileMenu = document.querySelector('.header-nav');
  const header = document.querySelector('.header-dv');
  const backdrop = document.querySelector('.header-dv__backdrop');

  // Function to open the mobile menu
  function openMobileMenu() {
    const headerHeight = header.offsetHeight;
    mobileMenu.style.display = 'block';
    mobileMenu.style.visibility = 'visible';
    mobileMenu.style.top = '-100%'; // Start off-screen
    hamburger.style.display = 'none';
    close.style.display = 'flex';
    backdrop.style.backgroundColor = 'rgb(27, 27, 33)';
    
    // Trigger reflow
    mobileMenu.offsetHeight;
    
    // Animate the menu sliding down
    mobileMenu.style.transition = 'top 0.3s ease-out';
    mobileMenu.style.top = `${headerHeight}px`;
  }

  // Function to close the mobile menu
  function closeMobileMenu() {
    mobileMenu.style.transition = 'top 0.3s ease-in';
    mobileMenu.style.top = '-100%'; // Slide back up
    
    // After animation, hide the menu
    setTimeout(() => {
      mobileMenu.style.display = 'none';
      mobileMenu.style.visibility = 'hidden';
    }, 300); // Match this with the transition duration
    
    hamburger.style.display = 'flex';
    close.style.display = 'none';
    backdrop.style.backgroundColor = '#302f3780';
  }

  // Add event listeners for opening and closing the menu
  hamburger.addEventListener('click', openMobileMenu);
  close.addEventListener('click', closeMobileMenu);
  clarifyTransparency();
});